// extracted by css-extract-rspack-plugin
export default {"Description":"MetadataInfo-module__Description___Yph0n","EmptyDescription":"MetadataInfo-module__EmptyDescription___lT8oy"};